<!-- As per multiple sources:
  https://github.com/angular/angular/issues/22588#issuecomment-409195501
  https://angular.dev/api/router/RouterLinkActive?tab=description
 -->
<div [routerLinkActiveOptions]="option.routerLinkActiveOptions ?? { exact: false }" routerLinkActive="active">
  <ng-container *ngFor="let route of option.routes; let first = first">
    <ng-container [ngSwitch]="first">
      <a
        *ngSwitchCase="true"
        [dataSelector]="'sidenav-link-option-' + option.label"
        class="sidenav-option link d-flex align-items-center px-4"
        [queryParams]="route.queryParams ?? {}"
        [routerLink]="route.path"
        (click)="option.onSelect()"
      >
        <anduin-icon class="pe-2" [name]="option.icon" [namespace]="option.iconNamespace ?? ''" />
        <span class="label flex-grow-1">{{ option.label }}</span>
        <pill *ngIf="option.notificationCount" class="pill" [dark]="true" [value]="option.notificationCount" color="red" size="small" />
        <span *ngIf="option.notificationCount" class="notification-dot"></span>
      </a>
      <a *ngSwitchCase="false" class="invisible-link" [queryParams]="route.queryParams ?? {}" [routerLink]="route.path"></a>
    </ng-container>
  </ng-container>
</div>
